import 'slick-carousel';
import $ from 'jquery';

const { speak } = wp.a11y;
const { sprintf, _x } = wp.i18n;

export default new class Slider {
  constructor() {
    this.selectors = {
      slider: '.js-slider',
    };

    this.init();
  }

  init() {
    $(this.selectors.slider).on('afterChange', (event, slick, currentSlide) => {
      let a11yText = sprintf(
        _x('Current slide %s', 'block', 'mdll'),
        currentSlide + 1,
      );

      if (slick.$nextArrow && slick.$nextArrow.hasClass('slick-disabled')) {
        a11yText = sprintf(
          _x(
            `Current slide %s. This is the last slide. Use previous button to load previous slides.`,
            'block',
            'mdll',
          ),
          currentSlide + 1,
        );
      }

      if (slick.$prevArrow && slick.$prevArrow.hasClass('slick-disabled')) {
        a11yText = _x(
          `You're currently on the first slide. Use next button to load more slides.`,
          'mdll',
        );
      }

      speak(a11yText);
    });

    // eslint-disable-next-line func-names
    $(this.selectors.slider).each(function() {
      const $slider = $(this);
      $slider.slick({
        slidesToShow: 4,
        nextArrow: $slider.parent().find('.js-slider-btn-next'),
        prevArrow: $slider.parent().find('.js-slider-btn-prev'),
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      });
    });
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/slider.js